import {
	confluenceLocalStorageInstance as localStorage,
	keys as localStorageKeys,
} from '@confluence/storage-manager';

import {
	createEligibilityCache,
	createWithEligibilityCache,
	type CacheController,
} from '@atlassian/cross-join-nudges';

type EligibilityCacheKey =
	| 'user_already_has_jira'
	| 'user_already_has_jpd'
	| 'jira_is_too_new'
	| 'jpd_is_too_new'
	| 'user_is_too_new'
	| 'user_cannot_request_jira_access'
	| 'user_cannot_request_jpd_access'
	| 'site_is_opted_out'
	| 'has_seen_jpd'
	| 'has_seen_jira'
	| 'has_enrolled_msr'
	| 'local_storage_enabled';

const cjnEligibilityCacheController: CacheController<EligibilityCacheKey> = {
	get: () => localStorage.getItem(localStorageKeys.CROSS_JOIN_NUDGES_ELIGIBILITY_KEY),
	set: (value) => localStorage.setItem(localStorageKeys.CROSS_JOIN_NUDGES_ELIGIBILITY_KEY, value),
	delete: () => localStorage.removeItem(localStorageKeys.CROSS_JOIN_NUDGES_ELIGIBILITY_KEY),
};

export const cjnEligibilityCacheHandler = createEligibilityCache(cjnEligibilityCacheController);
export const withEligibilityCache = createWithEligibilityCache<EligibilityCacheKey>(
	cjnEligibilityCacheHandler,
);

export const isCacheEnabled = async () => {
	await cjnEligibilityCacheHandler.set('local_storage_enabled', true);
	const value = await cjnEligibilityCacheHandler.get('local_storage_enabled');
	return value === true;
};
